import * as React from 'react';
import { Alert } from '@ixicare/ui';
import { WatcherrApiRequestError, WatcherrError } from '@ixicare/resources';
import { humaniseErrors } from '~utils/error';

interface ErrorContainerProps {
  error?: Error;
}

const joinFieldErrors = (fieldErrors?: Record<string, string[]>): string =>
  fieldErrors ? Object.values(fieldErrors).flat().join(' ') : '';

const ErrorContainer: React.FC<ErrorContainerProps> = ({ error }) => {
  if (!error) return null;
  if (error instanceof WatcherrApiRequestError) {
    const fieldMessage = joinFieldErrors(error.body?.fieldErrors);
    if (fieldMessage) return <Alert type="error">{fieldMessage}</Alert>;
  }
  if (error instanceof WatcherrError) {
    const { title } = humaniseErrors(error);
    return <Alert type="error">{title}</Alert>;
  }
  return <Alert type="error">{error.message}</Alert>;
};

export default ErrorContainer;
